// Choix de la collectivité (H7-01) : liste des collectivités actives ouvertes au portail, avec
// recherche ; le choix est mémorisé sur l'appareil et mène à l'accueil de la collectivité.
import { Champ, EtatVide } from '@cc/ui';
import { Building2 } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { EtatRequete } from '../../../commun/EtatRequete';
import { LIBELLES_TYPE_COLLECTIVITE, useCollectiviteChoisie, useCollectivitesPubliques } from '../collectivite';
import { EnTeteCitoyen, Ligne, Liste, Section } from '../commun';
import styles from '../citoyen.module.css';

const normaliser = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export function PageChoixCollectivite() {
  const collectivites = useCollectivitesPubliques();
  const [choisie, choisir] = useCollectiviteChoisie();
  const navigate = useNavigate();
  const [recherche, setRecherche] = useState('');
  const filtre = normaliser(recherche.trim());
  const visibles = (collectivites.data ?? []).filter((c) => !filtre || normaliser(`${c.nom} ${c.province} ${c.code}`).includes(filtre));

  return (
    <>
      <EnTeteCitoyen
        titre="Choisir votre collectivité"
        sousTitre="Votre compte est le même pour toutes les collectivités ; chaque démarche vise la commune ou le conseil départemental concerné."
      />
      {choisie ? (
        <Section titre="Collectivité actuelle">
          <Liste>
            <Ligne href={`/citoyen/${choisie.code}`} titre={choisie.nom} sousTitre="Revenir à l'accueil" droite="Actuelle" />
          </Liste>
        </Section>
      ) : null}
      <div className={styles.recherche}>
        <Champ
          id="recherche-collectivite"
          libelle="Rechercher une commune ou un conseil départemental"
          type="search"
          value={recherche}
          onChange={(e) => setRecherche(e.target.value)}
          autoComplete="off"
          placeholder="Nom, province ou code"
        />
      </div>
      <Section titre="Collectivités ouvertes au portail">
        <EtatRequete chargement={collectivites.isPending} erreur={collectivites.error} onReessayer={() => void collectivites.refetch()} fonction="La liste des collectivités">
          {visibles.length === 0 ? (
            <EtatVide titre={filtre ? 'Aucune collectivité ne correspond' : 'Aucune collectivité ouverte'} icone={Building2}>
              <p>{filtre ? 'Essayez un autre nom ou une province.' : 'Aucune collectivité active n\'est encore raccordée au portail.'}</p>
            </EtatVide>
          ) : (
            <Liste libelle="Collectivités">
              {visibles.map((c) => (
                <Ligne
                  key={c.code}
                  onClick={() => {
                    choisir({ code: c.code, nom: c.nom });
                    navigate(`/citoyen/${c.code}`);
                  }}
                  titre={c.nom}
                  sousTitre={`${LIBELLES_TYPE_COLLECTIVITE[c.type] ?? c.type} · ${c.province}`}
                  droite={<span className={styles.mono}>{c.code}</span>}
                />
              ))}
            </Liste>
          )}
        </EtatRequete>
      </Section>
    </>
  );
}
